import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowCircleDown} from '@fortawesome/pro-solid-svg-icons';
import {canDownloadSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionDownloadIcon = faArrowCircleDown;

/**
 * Download saved cart assets
 * @param params
 * @returns Action
 */
export const cartSavedActionDownload = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-download',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.DOWNLOAD, savedCart),
	enableTest: () => canDownloadSavedCart(savedCart),
	icon: cartSavedActionDownloadIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.DOWNLOAD;
	},
	...params,
});

export default cartSavedActionDownload;
